import { Model } from '../parents/model';

export class AddressModel extends Model {
  static ATTR_FIRST_NAME = 'first_name';

  static ATTR_LAST_NAME = 'last_name';

  static ATTR_PHONE = 'phone';

  static ATTR_DIAL_CODE = 'dial_code';

  static ATTR_STREET = 'street';

  static ATTR_CITY = 'city';

  static ATTR_POST_CODE = 'post_code';

  static ATTR_COUNTRY_ID = 'country_id';

  static ATTR_IS_COMPANY = 'is_company';

  static ATTR_COMPANY_NAME = 'company_name';

  static ATTR_COMPANY_IDENTIFICATION_NUMBER = 'company_identification_number';

  static ATTR_COMPANY_VAT_NUMBER = 'company_vat_number';

  get firstName() {
    return this.attributes[AddressModel.ATTR_FIRST_NAME];
  }

  get lastName() {
    return this.attributes[AddressModel.ATTR_LAST_NAME];
  }

  get phone() {
    return this.attributes[AddressModel.ATTR_PHONE];
  }

  get dialCode() {
    return this.attributes[AddressModel.ATTR_DIAL_CODE];
  }

  get street() {
    return this.attributes[AddressModel.ATTR_STREET];
  }

  get city() {
    return this.attributes[AddressModel.ATTR_CITY];
  }

  get postCode() {
    return this.attributes[AddressModel.ATTR_POST_CODE];
  }

  get isCompany() {
    return this.attributes[AddressModel.ATTR_IS_COMPANY];
  }

  get companyName() {
    return this.attributes[AddressModel.ATTR_COMPANY_NAME];
  }

  get companyIdentificationNumber() {
    return this.attributes[AddressModel.ATTR_COMPANY_IDENTIFICATION_NUMBER];
  }

  get companyVatNumber() {
    return this.attributes[AddressModel.ATTR_COMPANY_VAT_NUMBER];
  }

  get countryId() {
    return this.attributes[AddressModel.ATTR_COUNTRY_ID];
  }
}
